import React from 'react';

const Partners = () => {
  return (
    <section className="bg-white py-10 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-4">
          
          {/* Logo + Heading */}
          <div className="flex flex-col sm:flex-row items-center gap-6">
            <img className="h-32 w-auto" src="/logo.png" alt="Our Wipers" /> 

            <div className="hidden sm:block w-px h-10 bg-gray-300"></div>

            <h3 className="text-stone-600 font-bold text-lg md:text-sm tracking-wide text-center sm:text-left">
              Trusted by Local Shops and Regional Markets
            </h3>
          </div>

          {/* Instead of Partners Logos → Show Regions / Local Network */}
          <div className="flex flex-wrap justify-center items-end gap-8 md:gap-12">

            <div className="flex flex-col items-center">
              <div className="h-20 w-20 rounded bg-blue-100 flex items-center justify-center text-blue-600 text-xl font-bold">
                20+
              </div>
              <span className="text-gray-600 text-xs font-semibold uppercase tracking-wide mt-2 text-center">
                Local <br/> Shops
              </span>
            </div>

            <div className="flex flex-col items-center">
              <div className="h-20 w-20 rounded bg-green-100 flex items-center justify-center text-green-600 text-xl font-bold">
                5+
              </div>
              <span className="text-gray-600 text-xs font-semibold uppercase tracking-wide mt-2 text-center">
                States <br/> Served
              </span>
            </div>

            <div className="flex flex-col items-center">
              <div className="h-20 w-20 rounded bg-yellow-100 flex items-center justify-center text-yellow-600 text-xl font-bold">
                Export
              </div>
              <span className="text-gray-600 text-xs font-semibold uppercase tracking-wide mt-2 text-center">
                Neighbouring <br/> Countries
              </span>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
